export function timestamp(data: string): number {
    if (!data) { return 10000; }
    return Math.round(parseFloat(data) * 1000);
}

export function timestampFromDate(data: string|number): string {
    if (!data) { return null; }
    const date = (new Date(data).getTime() / 1000.0).toString();
    const parts = date.split('.');
    if (!parts[1]) { parts[1] = ''; }
    for (let i = 0 ; i < 6 - parts[1].length; i++) {
        parts[1] += '0';
    }
    return `${parts[0]}.${parts[1]}`;
}

export function utcDate(date: Date): number {
    if (!date) { return null; }
    return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
}

export function getBase64(file: File): Promise<string> {
    return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve((reader.result as string).split(',').pop());
        reader.onerror = error => reject(error);
    });
}

export function textToList(input: string) {
    if (input) {
        return input.replace(' ', '').split(',');
    } else {
        return [];
    }
}

export function rangePairs(start: number, end: number, step: number): Array<[number, number]> {
  const result = [];
  let previousStep = start;

  while(true) {
    const currentStep = previousStep + step;
    if(currentStep < end) {
      result.push([previousStep, currentStep]);
      previousStep = currentStep;
      continue;
    }

    result.push([previousStep, end]);
    break;
  }

  return result;
}

export function convertToCSV<T>(data: T[], transform: (data: T) => string[], headers?: string[]) {
  const csvRows = data.map(dp => transform(dp));
  const csvContent = headers ? [headers, ...csvRows] : csvRows;
  return csvContent.map(v => v.join(',')).join('\n');
}
